module.exports = __webpack_public_path__ + "static/media/class_5.eed99137.svg";